<template>
  <v-dialog v-model="isOpen" max-width="500">
    <v-card>
      <v-card-title class="c-modal__header">{{ $t("global.keeCredits.creditsTooLowTitle") }}</v-card-title>
      <v-card-text class="text-grey-darken-4 text-body-2">
        {{ $t("global.keeCredits.creditsTooLow", { count: MINIMUM_REQUIRED_KEE_CREDITS }) }}
      </v-card-text>
      <v-card-actions class="justify-end">
        <k-button primary @click="closeDialog">{{ $t("global.close") }}</k-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from "vue"

import { MINIMUM_REQUIRED_KEE_CREDITS } from "@/logic/keeCredits"
import { useKeeCreditsModalStore } from "@/store/keeCreditsModalStore"

const keeCreditsModalStore = useKeeCreditsModalStore()

const isOpen = computed({
  get() {
    return keeCreditsModalStore.isInsufficientCreditsDialogOpen
  },
  set(isDialogOpen: boolean) {
    if (isDialogOpen) {
      return
    }
    closeDialog()
  },
})

function closeDialog() {
  keeCreditsModalStore.closeInsufficientCreditsDialog()
}
</script>
